import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeCheckRollDayWiseMonthlyDetailReport } from './Pages/listing';

export const EmployeeCheckRollDayWiseMonthlyDetailReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={EmployeeCheckRollDayWiseMonthlyDetailReport} />
    </Fragment>
)